import React from "react";
import { HandThumbUpIcon, HandThumbDownIcon } from "@heroicons/react/20/solid";
import { PencilSquareIcon } from "@heroicons/react/24/outline";

interface TraceAnnotationProps {
  rating: boolean | null;
  showComment: boolean;
  commentText: string;
  submitting: boolean;
  onCommentTextChange: (text: string) => void;
  onGoodTrace: () => void;
  onBadTrace: () => void;
  onSubmitComment: () => void;
  onCancelComment: () => void;
}

export function TraceAnnotation({
  rating,
  showComment,
  commentText,
  submitting,
  onCommentTextChange,
  onGoodTrace,
  onBadTrace,
  onSubmitComment,
  onCancelComment,
}: TraceAnnotationProps) {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-5">
      <h3 className="text-sm font-semibold text-foreground flex items-center gap-2 mb-3">
        <PencilSquareIcon className="w-4 h-4 text-muted-foreground" />
        Trace Annotation
      </h3>
      <div className="flex gap-3">
        <button
          onClick={onGoodTrace}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-md border text-sm font-medium transition-colors ${
            rating === true
              ? "border-success bg-success/10 text-success"
              : "border-border bg-card text-muted-foreground hover:bg-accent"
          }`}
        >
          <HandThumbUpIcon className="w-4 h-4" />
          Good Trace
        </button>
        <button
          onClick={onBadTrace}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-md border text-sm font-medium transition-colors ${
            rating === false
              ? "border-destructive bg-destructive/10 text-destructive"
              : "border-border bg-card text-muted-foreground hover:bg-accent"
          }`}
        >
          <HandThumbDownIcon className="w-4 h-4" />
          Bad Trace
        </button>
      </div>

      {showComment && (
        <div className="mt-3 space-y-2">
          <textarea
            value={commentText}
            onChange={(e) => onCommentTextChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.metaKey) onSubmitComment();
            }}
            placeholder="What went wrong? (optional)"
            rows={3}
            className="w-full px-3 py-2 text-sm border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none"
          />
          <div className="flex gap-2 justify-end">
            <button
              onClick={onCancelComment}
              className="px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground"
            >
              Cancel
            </button>
            <button
              onClick={onSubmitComment}
              disabled={submitting}
              className="px-4 py-1.5 text-sm font-medium text-primary-foreground bg-primary rounded-md hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting ? "Submitting…" : "Submit"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
